<template>
  <transition name="slideDown">
    <transition name="slideDown">
      <modal title="Add Moods" v-if="show">
        <div class="form-horizontal">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="name"
                  class="col-sm-2 control-label">
                  Name
                </label>

                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Name"
                    v-model="optionForm.moods.name">
                </div>
              </div>

              <div class="form-group">
                <label for="slug"
                  class="col-sm-2 control-label">
                  Slug
                </label>

                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="slug"
                    placeholder="Slug"
                    v-model="optionForm.moods.slug">
                </div>
              </div>

              <div class="form-group">
                <label for="parent"
                  class="col-sm-2 control-label">
                  Image
                </label>

                <div class="col-sm-10">
                  <FileGallery
                    type="moods"
                    :inline="true"
                    @update-images="setImage"
                    :selected="optionForm.moods.image" />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 text-right">
              <button class="btn btn-primary"
                @click="addOption('moods')">
                Add
              </button>
            </div>
          </div>
        </div>
      </modal>
    </transition>
  </transition>
</template>

<script>
import FileGallery from '@/components/modules/common/FileGallery';
import Modal from '@/components/modules/common/Modal';

export default {
  props: {
    optionForm: {
      type: Object,
      required: true,
    },

    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    FileGallery,
    Modal,
  },

  methods: {
    setImage(payload) {
      this.$emit('setImage', payload);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/products/partials/ModalMoods.vue